import type { AssetClass } from '@/types'

export type UnderwritingFieldType = 'currency' | 'percentage' | 'number' | 'text' | 'select' | 'date' | 'calculated'

export interface UnderwritingField {
  id: string
  label: string
  type: UnderwritingFieldType
  section: string
  required: boolean
  formula?: string
  defaultValue?: number | string
  tooltip?: string
  assetClassSpecific: boolean
  selectOptions?: string[]
  suffix?: string
  prefix?: string
}

export interface UnderwritingSection {
  id: string
  label: string
  order: number
  fields: UnderwritingField[]
}

export interface UnderwritingModel {
  id: string
  assetClass: AssetClass
  version: number
  label: string
  sections: UnderwritingSection[]
  stressTestParams: string[]
  locked: boolean
  lockedBy?: string
  lockedAt?: string
  lastModified: string
  modifiedBy: string
}

/** Asset classes available for underwriting selection */
export const UNDERWRITING_ASSET_CLASSES: AssetClass[] = [
  'Multifamily',
  'Retail',
  'Office',
  'Industrial',
  'Hospitality',
  'Senior Living',
  'Construction',
  'Land',
  'Self-Storage',
  'Student Housing',
]
